// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2hl38","shimmer":"styles_shimmer__1m67P"};